module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form__fields"
  }, [_c('Textarea', {
    attrs: {
      "label": "Сопроводительное письмо *",
      "rows": 5
    },
    model: {
      value: (_vm.resultForm.text),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "text", $$v)
      },
      expression: "resultForm.text"
    }
  }), _c('File', {
    attrs: {
      "label": "Приложите файл резюме *",
      "text": "Файл jpeg, png, gif, pdf, word",
      "error-text": "Приложите файл выполненного задания",
      "warnings": _vm.fileWarnings,
      "fileName": _vm.resultForm.files.name
    },
    on: {
      "changeInput": _vm.inputFile
    }
  })], 1), _c('div', {
    staticClass: "form__buttons"
  }, [_c('Button', {
    attrs: {
      "size": "normal",
      "color": "default"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancelRequest')
      }
    }
  }, [_vm._v("Отменить")]), _c('Button', {
    attrs: {
      "size": "normal",
      "color": _vm.isDisabled ? 'disabled' : 'green',
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitVacancyForm
    }
  }, [_vm._v("Отправить заявку")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d479a5e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vacancies/form/components/requestform/RequestForm.vue
// module id = 37332f90c30b611562e6
// module chunks = 0